import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { OrderService, ProviderType } from 'src/app/services/order.service';
import { FileSelectEvent, FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-import',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule,
    TableModule,
    ToolbarModule,
    FileUploadModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './import.html',
  styles: [
    `
      .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(255, 255, 255, 0.8);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .spinner {
        border: 6px solid #f3f3f3;
        border-top: 6px solid #007ad9;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 0.8s linear infinite;
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class ImportComponent {
  loading = false;
  orderService = inject(OrderService);
  messageService = inject(MessageService);

  importOrder(event: FileSelectEvent, provider: ProviderType) {
    this.loading = true;
    this.orderService
      .importOrder(provider, event.files[0])
      .then((res) => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Importación exitosa',
          detail: `Se ha importado correctamente el pedido: Nuevos productos: ${res.data.new_products}, Líneas de pedido: ${res.data.order_lines}, ID de pedido: ${res.data.purchase_order_id}`,
          life: 10000,
        });
        console.log(res);
      })
      .catch((error) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error de importación',
          detail:
            'No se ha podido importar el pedido. Por favor, inténtelo de nuevo.',
          life: 5000,
        });
        console.error(error);
      });
  }
}
